import * as React from "react"
import { Link } from "react-router-dom"
import Button from "../../atoms/buttons/Button"
import { ArrowRight } from "../../atoms/icons/ArrowRight"
import { Inset, HorizontalSpacer } from "../../atoms/spacers"
import H2 from "../../atoms/typography/H2"
import H3 from "../../atoms/typography/H3"
import ArticleMetadata from "./ArticleMetadata"
import ResourceCard from "../../atoms/ResourceCard"
import ImageHeader from "../../atoms/ImageHeader"
import { ArticleModel } from "../../contentful/models"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import styled from "styled-components"

const Content = styled(Inset)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const ArticleCard: React.FunctionComponent<ArticleModel<string>> = (props) => {
  const inspectorProps = useContentfulInspectorMode({ entryId: props.sys?.id })
  return (
    <ResourceCard {...inspectorProps({ fieldId: "title" })}>
      <ImageHeader src={props.header?.url} width={100} />
      <Content spacing={2}>
        <div>
          <H2>{props.title}</H2>
          <HorizontalSpacer spacing={1} />
          <ArticleMetadata
            publishedAt={props.sys?.firstPublishedAt ? new Date(props.sys?.firstPublishedAt) : undefined}
            tags={props.tags ?? []}
          />
          <HorizontalSpacer spacing={1} />
          <H3>{props.description}</H3>
          <HorizontalSpacer spacing={2} />
        </div>
        <Link to={`/news/${props.slug}`}>
          <Button title="Read more" iconRight={<ArrowRight />} variant={props.color} size="normal" fullWidth={true} />
        </Link>
      </Content>
    </ResourceCard>
  )
}

export default ArticleCard
